import { ViewController, JsonFeed, ModelUpdateEvent, DataReceiveEvent, MaintenanceEvent, PlaybackStartEvent,
         VideoReloadEvent, TimeUpdateEvent, ChannelSwitchEvent, BetPlaceEvent } from "@gaming/srvg-classes-core";
import { RetailView } from "../../View/AppView/RetailView";
import { SeasonTextViewController } from "./SeasonTextViewController";
import { MatchdayTextViewController } from "./MatchdayTextViewController";
import { OverlayViewController } from "./OverlayViewController";
import { VideoController } from "./VideoController";
import { MatchdayAreaController } from "./MatchdayAreaController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export class RetailViewController extends ViewController {
    retailView: RetailView;

    seasonTextViewController: SeasonTextViewController;
    matchdayTextViewController: MatchdayTextViewController;
    overlayViewController: OverlayViewController;
    videoController: VideoController;
    matchdayAreaControllers: MatchdayAreaController[];

    constructor( options ) {
        options = options || {};
        options.view = options.retailView || null;
        super( options );
        this.name = 'vblRetailViewController';

        this.retailView = options.retailView || null;

        /******************* initialize controllers ************************/

        this.seasonTextViewController = this.addChildViewController( new SeasonTextViewController( { textView: this.retailView.seasonTextView } ) );
        this.matchdayTextViewController = this.addChildViewController( new MatchdayTextViewController( { textView: this.retailView.matchdayTextView } ) );

        this.videoController = this.addChildViewController( new VideoController( {
            videoView: this.retailView.videoView,
            videoControlBar: this.retailView.videoControlBar,
            channel: srvg.videooptions.defaultchannel
        } ) );

        this.overlayViewController    = this.addChildViewController( new OverlayViewController( {
            overlayView: this.retailView.overlayContainerView,
            teamAssignmentFeed: new JsonFeed( { url: srvg.url.teamJerseyAssignment } ),
            teamResultFeed: new JsonFeed( { url: srvg.url.teamResult } )
        } ) );

        this.matchdayAreaControllers = [];
        for( var i = 0; i < this.retailView.numberOfMatchdayAreas; i++ ) {
            this.matchdayAreaControllers.push( this.addChildViewController( new MatchdayAreaController({
                matchdayArea: this.retailView.matchdayAreas[i],
                matchdaypickerController: null
            }) ) );
        }

        /** FLOST **/

        if( srvg.videooptions.flostVideosets ) {
            this.videoController.initializeLocalStorage();
        }


        // force reload
        // activate for all retail instances
        if (srvg.featuresInstances.getEnableForceReloadFullRetail()){
            srvg.flost.setForceReloadCompatibleWithMinute( srvg.featuresInstances.getForceReload() );
        }else{
            // activate only for flost
            if( srvg.videooptions.flostVideosets ) {
                srvg.flost.setForceReloadCompatibleWithMinute( srvg.featuresInstances.getForceReload() );
            }
        }

        /******************* connect components ************************/
        app.timelineController.addSubscriberForEvent( srvg.maintenance,                 MaintenanceEvent );
        app.timelineController.addSubscriberForEvent( this.seasonTextViewController,    PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( this.matchdayTextViewController,  PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( app.server,                       TimeUpdateEvent );
        app.timelineController.addSubscriberForEvent( this.overlayViewController,       PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( this.videoController,             PhaseChangeEvent );
        app.timelineController.addSubscriberForEvent( this.videoController,             VideoReloadEvent );

        var exch = srvg.eventExchange;

        //___________________eventSubscriber____________________eventProvider______________eventType___________eventHandler_________________

        exch.addEventHandler(this.videoController,             'all',                      PlaybackStartEvent );
        exch.addEventHandler(this.videoController,             'all',                      ChannelSwitchEvent );
        exch.addEventHandler(this.overlayViewController,       'all',                      ChannelSwitchEvent );

        for( var i = 0; i < this.matchdayAreaControllers.length; i++ ) {
            var mdac = this.matchdayAreaControllers[i];
            mdac.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.oddsfeedController, ModelUpdateEvent );
            mdac.matchdayArea.matchdayAreaModel.addSubscriberForEvent( app.matchIdsFeedController, ModelUpdateEvent );
            mdac.matchdayArea.oddsGallery.addSubscriberForEvent( app.customerIntegration, BetPlaceEvent );
            exch.addEventHandler(mdac.oddsFrameViewController, 'all', ChannelSwitchEvent );
            app.oddsfeedController.addSubscriberForEvent( mdac, DataReceiveEvent );
        }

        /******************* start components ************************/
        app.timelineController.startPolling();
        if( ! srvg.videooptions.flostVideosets ) {
            this.videoController.play();
        }
        //this.customerIntegration.startCustomerActions();
    }
}